import React from "react";
import { connect } from "react-redux";

import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import state from "../../state";
import { inlineElements, generateStyle, setOverLay, l } from "../../functions";
import Icon from "../../components/Icons";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    fetchedProducts: state.rootReducer.fetchedProducts || {},
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class ShoppingCartSummary extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initButton = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;
    const settings = this.props.settings;

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");
    const semiBodyText = {
      color: settings["semi_body_color"]?.color || "black",
      fontSize: settings["semiBody"]?.size || 14,
    };

    const regButtonCss = {
      backgroundColor: settings["button_color"]?.bgColor || null,
      color: settings["button_text_color"]?.color || null,
    };
    const actButtonCss = {
      backgroundColor: settings["active_button_color"]?.bgColor || null,
      color: settings["active_button_text_color"]?.color || null,
    };

    const {
      showProductPicture,
      showProductAttribute,
      showRemoveProductButton,
      showChangeQtyAbility,
      showUnitPrice,
      showCartExpiringTimer,
      tableHeadColor,
      tableHeadBgColor,
      tableBodyBgColor,
      productNameColor,
      productAttributesColor,
      oldPriceColor,
      reducedPriceColor,
      removeButtonTextColor,
      removeButtonBackgroundColor,
      tableFootColor,
      tableFootBgColor,
      cartExpiringTimerColor,
      priceTotalColor,
    } = payload.datas || {};

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol" style={cssSettingsText}>
            <div className="shopping-cart">
              <div className="cart_navigation clearfix">
                <a
                  href="#0"
                  className="btn-checkout"
                  title="Checkout"
                  style={actButtonCss}
                >
                  Checkout
                </a>
              </div>
              <table className="shopping-table">
                <thead
                  className="tablelabel"
                  style={{ backgroundColor: tableHeadBgColor }}
                >
                  <tr>
                    {showProductPicture !== undefined &&
                    showProductPicture !== null &&
                    showProductPicture === false ? null : (
                      <th
                        className="imgcol"
                        scope="col"
                        style={{ color: tableHeadColor, width: 50 }}
                      ></th>
                    )}
                    <th
                      className="productcol"
                      scope="col"
                      style={{ color: tableHeadColor }}
                    >
                      Product
                    </th>
                    {showChangeQtyAbility !== undefined &&
                    showChangeQtyAbility !== null &&
                    showChangeQtyAbility === false ? null : (
                      <th
                        className="qtycol"
                        scope="col"
                        style={{ color: tableHeadColor }}
                      >
                        Quantity
                      </th>
                    )}
                    <th
                      className="totalcol"
                      scope="col"
                      colSpan={2}
                      style={{ color: tableHeadColor }}
                    >
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody style={{ backgroundColor: tableBodyBgColor }}>
                  {Object.keys(this.props.fetchedProducts)
                    .slice(0, 3)
                    .map((id_product, key) => {
                      const product = this.props.fetchedProducts[id_product];

                      return (
                        <tr key={key}>
                          {showProductPicture !== undefined &&
                          showProductPicture !== null &&
                          showProductPicture === false ? null : (
                            <td>
                              <img style={{ width: 50 }} src={product.image} />
                            </td>
                          )}
                          <td className="productcol">
                            <div className="productinfo">
                              <p style={{ color: productNameColor }}>
                                <span>{product.name}</span>
                              </p>
                              {showProductAttribute !== undefined &&
                              showProductAttribute !== null &&
                              showProductAttribute === false ? null : (
                                <p
                                  className="attr"
                                  style={{ color: productAttributesColor }}
                                >
                                  <span
                                    className="attr-option"
                                    style={semiBodyText}
                                  >
                                    Color : Coffee
                                  </span>
                                  <span
                                    className="attr-option"
                                    style={semiBodyText}
                                  >
                                    Ships From : China
                                  </span>
                                </p>
                              )}
                              {showRemoveProductButton !== undefined &&
                              showRemoveProductButton !== null &&
                              showRemoveProductButton === false ? null : (
                                <button
                                  type="button"
                                  className="cpt-remove btn btn-light"
                                  style={regButtonCss}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          </td>
                          {showChangeQtyAbility !== undefined &&
                          showChangeQtyAbility !== null &&
                          showChangeQtyAbility === false ? null : (
                            <td>
                              <div className="qtybox">
                                <div className="button-container">
                                  <input
                                    className="qty txtIdNumproduct1 input-text qty"
                                    type="text"
                                    value={1}
                                    onChange={() => {}}
                                  />
                                  <button className="qty-minus" type="button">
                                    <FontAwesomeIcon
                                      icon={["fas", "sort-up"]}
                                    />
                                  </button>
                                  <button className="qty-plus" type="button">
                                    <FontAwesomeIcon
                                      icon={["fas", "sort-down"]}
                                    />
                                  </button>
                                </div>
                              </div>
                            </td>
                          )}
                          <td className="totalcol" colSpan={2}>
                            <span
                              className="cart-price"
                              style={{ color: reducedPriceColor }}
                            >
                              {product.price["reduced-price"]}
                              <span
                                className="old-price"
                                style={{ color: oldPriceColor }}
                              >
                                {product.price["old-price"]}
                              </span>
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
                <tfoot style={{ backgroundColor: tableFootBgColor }}>
                  <tr>
                    <td
                      colSpan={
                        showProductPicture !== undefined &&
                        showProductPicture !== null &&
                        showProductPicture === false
                          ? 1
                          : 2
                      }
                      className="hidden-xs shopping-cart-subtotal cart-time timer-td"
                      style={{ color: tableFootColor }}
                    >
                      {showCartExpiringTimer !== undefined &&
                      showCartExpiringTimer !== null &&
                      showCartExpiringTimer === false ? null : (
                        <span>
                          Cart will expire in:{" "}
                          <span
                            className="timer"
                            style={{ color: cartExpiringTimerColor }}
                          >
                            3:19
                          </span>
                        </span>
                      )}
                    </td>
                    <td
                      className="hide productcol"
                      style={{ color: tableFootColor }}
                    >
                      Subtotal
                    </td>
                    {showChangeQtyAbility !== undefined &&
                    showChangeQtyAbility !== null &&
                    showChangeQtyAbility === false ? null : (
                      <td className="hide">&nbsp;</td>
                    )}
                    <td
                      className="cart-price"
                      colSpan={
                        showUnitPrice !== undefined &&
                        showUnitPrice !== null &&
                        showUnitPrice === false
                          ? 2
                          : 1
                      }
                      style={{ color: tableFootColor }}
                    >
                      <span
                        className="cart-price-bottom"
                        style={{ color: priceTotalColor }}
                      >
                        --
                      </span>
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div className="cart_navigation clearfix">
                <a
                  href="#0"
                  className="btn-continue"
                  title="Continue shopping"
                  style={regButtonCss}
                >
                  Continue shopping
                </a>
                <a
                  href="#0"
                  className="btn-checkout"
                  title="Checkout"
                  style={actButtonCss}
                >
                  Checkout
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className="added">{l("Added")}</span>) || (
              <span className="required">{l("Required")}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initButton()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initButton()}
      </Draggable>
    );
  }
}

ShoppingCartSummary.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ShoppingCartSummary);
